<app-page-title [label]="label()" [canGoBack]="true" [routerLink]="['/reports']"></app-page-title>

<app-org-export (onReportLoaded)="reportLoaded($event)"></app-org-export>
